var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "35",
        height: "34",
        viewBox: "0 0 35 34",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d: "M21.9272 12.7701L16.3765 18.4918L12.7344 29.2999",
          stroke: "#179E7E",
          "stroke-width": "1.1869"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M27.6476 15.5984L26.9526 16.0998L25.1714 15.0955L23.893 11.6149L24.4718 11.1974L24.4712 11.1966L25.0504 10.7788L27.9502 13.0894L28.3416 15.0965L27.647 15.5976L27.6476 15.5984Z",
          fill: "#E1503C"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M26.9105 16.0416L25.1454 14.9375L23.774 11.0839",
          stroke: "black",
          "stroke-width": "0.75"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M30.4323 11.0862L30.2955 11.9321L28.3257 12.4815L24.9607 10.9243L25.0748 10.2194L30.4323 11.0862ZM30.4317 11.0857L30.5685 10.2398L28.8726 9.09731L25.1882 9.51395L25.0741 10.2189L30.4317 11.0857Z",
          fill: "#E1503C"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M30.2253 11.9207L28.1965 12.3882L24.5018 10.633",
          stroke: "black",
          "stroke-width": "0.75"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M17.9774 14.0325L18.4787 14.7274L20.4858 14.336L22.7965 11.4362L22.3787 10.8571L22.3787 10.8571L21.9609 10.278L18.4803 11.5563L17.476 13.3376L17.9774 14.0325L17.9774 14.0325Z",
          fill: "#E1503C"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M18.5364 14.6847L20.5596 14.1936L23.0763 10.9691",
          stroke: "black",
          "stroke-width": "0.75"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M29.2123 5.92612L29.7137 6.62106L28.7093 8.40233L25.2288 9.68066L24.811 9.10155L29.2123 5.92612ZM29.2109 5.92704L28.7095 5.23209L26.7024 5.62348L24.3918 8.52335L24.8096 9.10246L29.2109 5.92704Z",
          fill: "#E1503C"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M29.6558 6.66316L28.5518 8.4283L24.6981 9.79972",
          stroke: "black",
          "stroke-width": "0.75"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M22.4879 16.8176L21.642 16.6808L21.0926 14.7111L22.6498 11.346L23.3546 11.4601L23.3548 11.4585L24.0598 11.5725L24.4764 15.2569L23.3339 16.9529L22.4881 16.816L22.4879 16.8176Z",
          fill: "#E1503C"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M23.3455 16.8832L24.4289 15.1053L23.9283 11.0457",
          stroke: "black",
          "stroke-width": "0.75"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M16.7563 8.87196L16.6194 9.71789L18.3154 10.8604L21.9998 10.4437L22.1138 9.73882L22.1155 9.73909L22.2295 9.03415L18.8645 7.47695L16.8948 8.02634L16.7579 8.87223L16.7563 8.87196Z",
          fill: "#E1503C"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M16.6904 9.73095L18.4683 10.8143L22.528 10.3137",
          stroke: "black",
          "stroke-width": "0.75"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M16.7563 8.87196L16.6194 9.71789L18.3154 10.8604L21.9998 10.4437L22.1138 9.73882L22.1155 9.73909L22.2295 9.03415L18.8645 7.47695L16.8948 8.02634L16.7579 8.87223L16.7563 8.87196Z",
          fill: "#E1503C"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M16.6904 9.73095L18.4683 10.8143L22.528 10.3137",
          stroke: "black",
          "stroke-width": "0.75"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M16.7563 8.87196L16.6194 9.71789L18.3154 10.8604L21.9998 10.4437L22.1138 9.73882L22.1155 9.73909L22.2295 9.03415L18.8645 7.47695L16.8948 8.02634L16.7579 8.87223L16.7563 8.87196Z",
          fill: "#E1503C"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M16.6904 9.73095L18.4683 10.8143L22.528 10.3137",
          stroke: "black",
          "stroke-width": "0.75"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M19.5417 4.36242L18.8467 4.8638L19.2381 6.8709L22.138 9.18154L22.7168 8.76393L22.717 8.76414L23.2961 8.34632L22.0178 4.86578L20.2365 3.86146L19.5418 4.36263L19.5417 4.36242Z",
          fill: "#E1503C"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M18.8883 4.92323L19.3794 6.94646L22.604 9.4631",
          stroke: "black",
          "stroke-width": "0.75"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M24.7011 3.139L23.8551 3.00213L22.7126 4.69812L23.1293 8.3825L23.8341 8.49654L23.834 8.49756L24.5389 8.61162L26.0961 5.24658L25.5467 3.27687L24.7009 3.14002L24.7011 3.139Z",
          fill: "#E1503C"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M23.8438 3.07484L22.7604 4.85272L23.261 8.91239",
          stroke: "black",
          "stroke-width": "0.75"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M23.026 8.07755L23.1478 7.98964L23.2966 8.01018L24.557 8.18413L24.7159 8.20606L24.8098 8.33619L25.5367 9.34369L25.6306 9.47382L25.6013 9.63158L25.3689 10.8824L25.3415 11.0302L25.2196 11.1181L24.1642 11.8796L24.0423 11.9675L23.8935 11.9469L22.6332 11.773L22.4742 11.751L22.3803 11.6209L21.6534 10.6134L21.5596 10.4833L21.5889 10.3255L21.8212 9.07467L21.8487 8.92695L21.9705 8.83904L23.026 8.07755Z",
          fill: "#EEA71F",
          stroke: "black",
          "stroke-width": "0.75"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M22.0699 19.9988L22.793 18.848L15.0573 21.5371L15.091 22.2761L15.9689 23.2159L15.976 23.2367L16.861 23.2811L17.3242 22.7722L16.9882 21.778L16.9941 21.7759L18.7468 22.5984L19.7799 22.3489L19.6799 21.6849L18.7381 21.2466L21.2234 21.4537L21.8849 20.9836L21.6943 20.4392L20.9815 20.3798L22.0699 19.9988Z",
          fill: "#179E7E"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M9.93238 15.8387L15.3785 20.4928L16.7877 29.6514",
          stroke: "#179E7E",
          "stroke-width": "1.1869"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M5.87954 20.8267L5.1139 20.4419L5.18216 18.3981L7.67905 15.657L8.31666 15.9775L8.31702 15.9767L8.95505 16.2975L8.24465 19.9367L6.64512 21.2107L5.87991 20.826L5.87954 20.8267Z",
          fill: "#802EEA"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M6.83766 21.4817L8.24493 19.7791L8.98809 15.7567",
          stroke: "black",
          "stroke-width": "0.75"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M2.41414 16.8165L2.68338 17.6301L4.71528 17.8602L7.7909 15.7893L7.56653 15.1113L2.41414 16.8165ZM2.41414 16.8164L2.1449 16.0028L3.63832 14.6059L7.34216 14.4332L7.56653 15.1112L2.41414 16.8164Z",
          fill: "#802EEA"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M2.75147 17.607L4.82872 17.7469L8.19844 15.4282",
          stroke: "black",
          "stroke-width": "0.75"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M15.1793 17.7524L15.5642 16.9868L14.2902 15.3872L10.651 14.6768L10.3305 15.3144L10.3303 15.3143L10.0096 15.9523L12.7507 18.4492L14.7945 18.5175L15.1791 17.7523L15.1793 17.7524Z",
          fill: "#802EEA"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M14.9121 18.659L12.6554 18.3215L9.6594 15.5366",
          stroke: "black",
          "stroke-width": "0.75"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M2.80095 11.5268L2.41608 12.2924L3.69008 13.892L7.32926 14.6024L7.64972 13.9649L7.65156 13.9658L7.97229 13.3278L5.23115 10.8309L3.18739 10.7626L2.80278 11.5277L2.80095 11.5268Z",
          fill: "#802EEA"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M2.48014 12.3247L3.85002 13.8925L7.87236 14.6357",
          stroke: "black",
          "stroke-width": "0.75"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M11.1669 21.2162L11.9804 20.9469L12.2106 18.915L10.1396 15.8394L9.46199 16.0637L9.46186 16.0633L8.78391 16.2876L8.95662 19.9915L10.3535 21.4849L11.1667 21.2158L11.1669 21.2162Z",
          fill: "#802EEA"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M9.88414 21.7471L8.97966 19.8338L8.83036 15.7461",
          stroke: "black",
          "stroke-width": "0.75"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M15.5666 12.4607L15.8358 13.2743L14.3424 14.6712L10.6386 14.8439L10.4148 14.1677L10.4125 14.1684L10.1881 13.4905L13.2637 11.4195L15.2956 11.6497L15.5643 12.4615L15.5666 12.4607Z",
          fill: "#802EEA"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M15.7682 13.298L14.1845 14.6495L10.0968 14.7988",
          stroke: "black",
          "stroke-width": "0.75"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M15.5666 12.4607L15.8358 13.2743L14.3424 14.6712L10.6386 14.8439L10.4148 14.1677L10.4125 14.1684L10.1881 13.4905L13.2637 11.4195L15.2956 11.6497L15.5643 12.4615L15.5666 12.4607Z",
          fill: "#802EEA"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M15.7682 13.298L14.1845 14.6495L10.0968 14.7988",
          stroke: "black",
          "stroke-width": "0.75"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M15.5666 12.4607L15.8358 13.2743L14.3424 14.6712L10.6386 14.8439L10.4148 14.1677L10.4125 14.1684L10.1881 13.4905L13.2637 11.4195L15.2956 11.6497L15.5643 12.4615L15.5666 12.4607Z",
          fill: "#802EEA"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M15.7682 13.298L14.1845 14.6495L10.0968 14.7988",
          stroke: "black",
          "stroke-width": "0.75"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M12.1015 8.45179L12.8672 8.83666L12.7989 10.8804L10.302 13.6216L9.66399 13.3008L12.1015 8.45179ZM12.1014 8.45184L11.3358 8.06696L9.73625 9.34097L9.02585 12.9801L9.66388 13.3009L12.1014 8.45184Z",
          fill: "#802EEA"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M12.8351 8.89971L12.671 10.9752L9.88613 13.9712",
          stroke: "black",
          "stroke-width": "0.75"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M6.81392 8.06261L7.62745 7.79337L9.02434 9.28679L9.19705 12.9906L8.5191 13.215L6.81392 8.06261ZM6.81397 8.06307L6.00043 8.33231L5.77025 10.3642L7.84121 13.4398L8.51915 13.2155L6.81397 8.06307Z",
          fill: "#802EEA"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M7.64989 7.86127L9.00142 9.44492L9.15072 13.5326",
          stroke: "black",
          "stroke-width": "0.75"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M9.25081 12.6716L9.11657 12.6041L8.97287 12.648L7.75607 13.0195L7.60261 13.0664L7.53054 13.2097L6.97257 14.3197L6.9005 14.4631L6.95444 14.6142L7.38214 15.8124L7.43265 15.9539L7.56689 16.0214L8.72973 16.6059L8.86397 16.6734L9.00767 16.6296L10.2245 16.258L10.3779 16.2112L10.45 16.0678L11.008 14.9578L11.08 14.8144L11.0261 14.6633L10.5984 13.4651L10.5479 13.3236L10.4136 13.2561L9.25081 12.6716Z",
          fill: "#EEA71F",
          stroke: "black",
          "stroke-width": "0.75"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }